import { render, staticRenderFns } from "./BaseImageModal.vue?vue&type=template&id=ea67e63c&"
import script from "./BaseImageModal.vue?vue&type=script&lang=js&"
export * from "./BaseImageModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports